import { Fragment } from 'react'
import { useFormContext } from 'react-hook-form';
// Redux
import { useAppDispatch, useAppSelector } from 'app/hooks/useStore';
// Async
import { updateConversation } from 'app/store/AIChat/AIChat.async';
// Selectors
import { selectConversation } from 'app/store/AIChat/AIChat.selectors';
// Mui
import { Badge, Tooltip } from '@mui/material';
// Icons
import { AttachFile as AttachFileIcon } from '@mui/icons-material';
// Components
import { IconButton } from 'app/components/Mui';
// Hooks
import useToggle from 'app/hooks/useToggle';
// Dialogs
import ChatDocumentsDialog from './ChatDocumentsDialog';

type Props = {
  disableControls: boolean;
}

export default function ChatMessageDocumentButton({ disableControls }: Props) {
  // Dispatch
  const dispatch = useAppDispatch();
  // State
  const conversation = useAppSelector(selectConversation);;

  const { setValue, watch } = useFormContext();

  const { open, toggle } = useToggle();

  const handleClose = (documentIds?: number[]) => {
    toggle();
    if ( typeof documentIds !== 'undefined' ){
      setValue('documentIds', documentIds);
      // Update conversation with new documentIds if conversation exists
      if ( conversation ){
        const { id, ...restConversationData } = conversation;
        // Update conversation with new documentIds if conversation exists
        return void dispatch(updateConversation({
          conversationId: id,
          data: { ...restConversationData, documentIds }
        }));
      }
    }
  }

  
  const documentIds = watch('documentIds') || [];
  const hasDocumentIds = documentIds.length > 0;

  return (
    <Fragment>
      <Tooltip title="Documents">
        {/* Tooltip doesn`t work with disabled button, span added */}
        <span>
          <IconButton
            name="Documents"
            aria-label="Documents"
            onClick={toggle}
            disabled={disableControls}
          >
            <Badge color="error" variant="dot" invisible={!hasDocumentIds}>
              <AttachFileIcon />
            </Badge>
          </IconButton>
        </span>
      </Tooltip>
      {open ? (
        <ChatDocumentsDialog
          open={open}
          onClose={handleClose}
          documentIds={documentIds}
        />
      ) : null}
    </Fragment>
  )
}
